// VASRatingInput.jsx

function VASRatingInput({
  label,
  VASValue = null, 
  setVASValue, 
  index,
}) {
  const sliderId = `slider-${label}-${index}`;

  const onSliderChange = (event) => {
    setVASValue(parseInt(event.target.value, 10)); 
  };

  return (
    <div className="capevr-vocal-attribute-rating">
      <div className="capevr-rating-row">
        <label htmlFor={sliderId} className="capevr-rating-label">
          {label}
        </label>
        <input
          type="range"
          id={sliderId}
          name={sliderId}
          min="0"
          max="100"
          value={VASValue ?? 0} 
          onChange={onSliderChange}
          className="capevr-slider"
        />
      </div>
    </div>
  );
}

export default VASRatingInput;
